/**
 * Channel names excluded from Program Analysis livestream top-10 rankings
 * (screenshot asset, preview, social copy). Match is case-insensitive, trimmed.
 */
const EXCLUDED_LIVESTREAM_RANKING_CHANNEL_NAMES_LOWER = new Set([
  "felipe avello oficial",
]);

export function isExcludedLivestreamRankingChannelName(
  channelName: string,
): boolean {
  return EXCLUDED_LIVESTREAM_RANKING_CHANNEL_NAMES_LOWER.has(
    channelName.trim().toLowerCase(),
  );
}
